import { createContext, useContext } from "react";

import type { Notification } from "~/providers/notification-provider";

interface NotificationContext {
  notifications: Notification[];
  totalUnseen: number;
}

export const NotificationContext = createContext<
  NotificationContext | undefined
>(undefined);

export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (context === undefined) {
    throw new Error(
      "useNotification must be used within a NotificationProvider, but no provider was found",
    );
  }

  return context;
};
